import React, { memo } from 'react';
import { useTranslation } from '@dm/i18n';
import { theme } from '../../..';
import { IconProps, DEFAULT_IMAGE_SIZE } from '../icon';
import IconSvg from '../IconSvg';

const Cross = (props: IconProps) => {
  const [t] = useTranslation();
  const {
    id,
    color = theme.palette.color2.hex,
    description,
    dmId = 'dm-cross',
    pointerEvents = 'none',
    secondColor,
    size = DEFAULT_IMAGE_SIZE,
    title = t('ds.icon.cross.title'),
    ...otherProps
  } = props; // we also need to define unused props because of otherProps

  return (
    <IconSvg
      id={id}
      description={description}
      dmId={dmId}
      fill={color}
      pointerEvents={pointerEvents}
      size={size}
      title={title}
      {...otherProps}>
      <path d="M2.5,2.61c1.35-1.33,3.26,0.52,3.26,0.52l14.9,14.9c0,0,2.4,2.18,0.74,3.54c-1.65,1.37-3.71-1.15-3.71-1.15L2.88,5.61C2.88,5.61,1.16,3.93,2.5,2.61z M2.54,21.53c-1.4-1.47,0.81-3.5,0.81-3.5L18.11,3.26c0,0,1.8-2.16,3.25-0.79c1.45,1.37-0.53,3.43-0.53,3.43L6.25,20.48C6.25,20.48,3.94,23,2.54,21.53z" />
    </IconSvg>
  );
};

export default memo(Cross);
